import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginModal from "./auth/LoginModal";
import SignupModal from "./auth/SignupModal";
import axios from "axios";
import DynamicPage from "./components/DynamicPage";
import { fetchCategories } from "./services/apiService";
import DynamicPageWrapper from "./components/DynamicPageWrapper";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WishlistPage from "./components/WishlistPage";

const RootComponent = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const loadCategories = async () => {
      const data = await fetchCategories();
      setCategories(data);
    };
    loadCategories();
  }, []);

  return (
    <Auth0Provider
      domain="dev-kl3meji5hz28y376.us.auth0.com"
      clientId="GNmW9JWeGX8x2iTVBsZeYbPc7slHeLOy"
      authorizationParams={{ redirect_uri: window.location.origin }}
    >
      <Router>
        <Routes>
          <Route path="/" element={<App categories={categories} />} />
          <Route path="/login" element={<LoginModal />} />
          <Route path="/signup" element={<SignupModal />} />
          <Route
            path="/trips/:tripPath"
            element={<DynamicPageWrapper categories={categories} />}
          />
          <Route path="/wishlist" element={<WishlistPage />} />
        </Routes>
      </Router>
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <RootComponent />
    <ToastContainer position="top-right" autoClose={3000} newestOnTop />
  </>
);
reportWebVitals();
